var _LogQueue_config, _LogQueue_queue, _LogQueue_isShutdown;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { exportCommon } from './utils';
export class LogQueue {
    constructor(config) {
        _LogQueue_config.set(this, void 0);
        _LogQueue_queue.set(this, []);
        _LogQueue_isShutdown.set(this, false);
        __classPrivateFieldSet(this, _LogQueue_config, config, "f");
        setInterval(() => {
            this.flush();
        }, __classPrivateFieldGet(this, _LogQueue_config, "f").flushConfig.flushIntervalMs);
    }
    push(logRecord) {
        if (__classPrivateFieldGet(this, _LogQueue_isShutdown, "f")) {
            console.error('Attempting to log to a shutdown queue');
            return;
        }
        if (__classPrivateFieldGet(this, _LogQueue_queue, "f").length >= __classPrivateFieldGet(this, _LogQueue_config, "f").flushConfig.maxQueueSize) {
            __classPrivateFieldGet(this, _LogQueue_queue, "f").shift();
        }
        __classPrivateFieldGet(this, _LogQueue_queue, "f").push(logRecord);
        if (__classPrivateFieldGet(this, _LogQueue_queue, "f").length >= __classPrivateFieldGet(this, _LogQueue_config, "f").flushConfig.maxQueueSize &&
            __classPrivateFieldGet(this, _LogQueue_config, "f").flushConfig.flushOnFull) {
            this.flush();
        }
    }
    async flush() {
        if (__classPrivateFieldGet(this, _LogQueue_isShutdown, "f")) {
            return;
        }
        if (__classPrivateFieldGet(this, _LogQueue_queue, "f").length > 0) {
            const records = __classPrivateFieldGet(this, _LogQueue_queue, "f").splice(0, 10);
            await exportCommon(__classPrivateFieldGet(this, _LogQueue_config, "f").exporter, records);
            if (__classPrivateFieldGet(this, _LogQueue_queue, "f").length) {
                await this.flush();
            }
        }
    }
    async shutdown() {
        await this.flush();
        await __classPrivateFieldGet(this, _LogQueue_config, "f").exporter.shutdown();
        __classPrivateFieldSet(this, _LogQueue_isShutdown, true, "f");
    }
}
_LogQueue_config = new WeakMap(), _LogQueue_queue = new WeakMap(), _LogQueue_isShutdown = new WeakMap();
//# sourceMappingURL=log-queue.js.map